import React, { useState, useEffect } from 'react';
import axios from 'axios';
import PageWrapper from '../components/PageWrapper';
import AdminPanel from '../AdminPanel';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AdminAccess = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const adminAuth = sessionStorage.getItem('uro2go_admin_auth');
    if (adminAuth === 'true') {
      setIsAuthenticated(true);
    }
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${API}/admin/login`, { password });
      if (response.data.authenticated) {
        sessionStorage.setItem('uro2go_admin_auth', 'true');
        setIsAuthenticated(true);
        setError('');
      }
    } catch (err) {
      setError('Invalid password');
    }
  };

  const handleLogout = () => {
    sessionStorage.removeItem('uro2go_admin_auth');
    setIsAuthenticated(false);
  };

  if (!isAuthenticated) {
    return (
      <PageWrapper>
        <div className="admin-login" data-testid="admin-login">
          <h2>Admin Access</h2>
          <form onSubmit={handleLogin}>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter admin password"
              data-testid="admin-password-input"
            />
            {error && <p className="error-text" data-testid="admin-error">{error}</p>}
            <button type="submit" className="btn-primary" data-testid="admin-login-btn">Login</button>
          </form>
        </div>
      </PageWrapper>
    );
  }

  return (
    <PageWrapper>
      <div className="admin-header" data-testid="admin-header">
        <h2>Admin Panel</h2>
        <button onClick={handleLogout} className="btn-secondary" data-testid="admin-logout-btn">Logout</button>
      </div>
      <AdminPanel onLogout={handleLogout} />
    </PageWrapper>
  );
};

export default AdminAccess;
